module.exports = __webpack_public_path__ + "media/images/realizacje/real7-a2824a4bc2475adb195f2617aab8e686.png";